import _objectSpread from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import { ConfigurationReference } from '@jbrowse/core/configuration/configurationSchema';
import { getParentRenderProps } from '@jbrowse/core/util/tracks';
import { types } from 'mobx-state-tree';
import { BaseLinearDisplay } from '../BaseLinearDisplay';
/**
 * #stateModel LinearBareDisplay
 * extends `BaseLinearDisplay`
 */
export function stateModelFactory(configSchema) {
  return types.compose('LinearBareDisplay', BaseLinearDisplay, types.model({
    /**
     * #property
     */
    type: types.literal('LinearBareDisplay'),
    /**
     * #property
     */
    configuration: ConfigurationReference(configSchema)
  })).views(function (self) {
    var superRenderProps = self.renderProps;
    return {
      /**
       * #method
       */
      renderProps: function renderProps() {
        return _objectSpread({}, superRenderProps(), getParentRenderProps(self), {
          rpcDriverName: self.rpcDriverName,
          config: self.configuration.renderer
        });
      },
      /**
       * #getter
       */
      get rendererTypeName() {
        return self.configuration.renderer.type;
      }
    };
  });
}